<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/proGroup/productlist">产品展示组</BreadcrumbItem>
          <BreadcrumbItem>编辑展示组</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/exhibition/index/proGroup/productlist')">返回</Button>
      </div>
    </div>
    <div class="custom-wrap" v-if="show">
      <!-- <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(customData)}}</div>
      <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(defaultArr)}}</div>-->
      <customComponent v-model="customData" :type="3" :defaultArr="defaultArr" ref="customComponent"></customComponent>
      <div class="custom-btn">
        <Button
          type="primary"
          size="large" 
          @click="saveCustom()"
          style="width: 154px;"
        >保存</Button>
      </div> 
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import customComponent from "@components/custom-component/custom-component";
export default {
  name: "product-group-edit",
  data() {
    return {
      editData: null,
      customData: [],
      defaultArr: null,
      show: false
    };
  },
  watch: {
    customData(val, oldVal) {
      console.log("customData: ", val);
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  components: {
    customComponent
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductGroupById: "productModule/getProductGroupById",
      editProductGroup: "productModule/editProductGroup",

      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    async init() {
      if (!this.query.id) return;
      this.editData = await this.getProductGroupById(this.query.id);
      this.setData();
    },
    async setData() {
      if (!this.editData) return;
      let defaultArr = {
        title: "产品分组",
        type: "product",
        icon: "",
        componentName: "customProduct",
        config: {
          type: 1,
          Name: this.editData.name, // 分组名称
          ShowGroupName: this.editData.showGroupName, // 显示分组名称
          FirstPriority: this.editData.firstPriority, // 第一显示优先级
          SecondPriority: this.editData.secondPriority, // 第二显示优先级
          ListStyle: this.editData.listStyle, // 列表样式
          ShowProductName: this.editData.showProductName, // 显示产品的名称
          ShowProductPrice: this.editData.showProductPrice, // 显示产品的价格
          Introduction: "" // 分组的描述
        }
      };
      let otherArr = [];
      let Introduction = this.editData.introduction;
      if (Introduction && Introduction.indexOf("[") !== -1) {
        otherArr = await this.transformCustomData(JSON.parse(Introduction));
      }
      this.customData = otherArr;
      this.defaultArr = [defaultArr];
      this.show = true;
    },
    async saveCustom() {
      this.$refs["customComponent"].saveCustom();
      setTimeout(() => {
        console.log(this.customData);
        const req = this.transformData();
        console.log(req);
        this.editProduct(req);
      }, 400);
    },
    transformData() {
      if (!this.customData) return;
      let data = [];
      let copyData = JSON.parse(JSON.stringify(this.customData));
      copyData.forEach(c => {
        const key = Object.keys(c);
        if (key && key[0] === "product") {
          this.groupData = c.product;
        } else {
          data.push(c);
        }
      });
      this.otherData = data;
      const req = {
        Id: this.$router.history.current.query.id,
        SetValues: {
          Name: this.groupData.Name,
          ShowGroupName: this.groupData.ShowGroupName,
          FirstPriority: this.groupData.FirstPriority,
          SecondPriority: this.groupData.SecondPriority,
          ListStyle: this.groupData.ListStyle,
          ShowBuyButton: 0,
          BuyButtonStyle: 1,
          ShowProductName: this.groupData.ShowProductName,
          ShowProductPrice: this.groupData.ShowProductPrice,
          Introduction: JSON.stringify(this.otherData)
        }
      };
      console.log(req);
      return req;
    },
    async editProduct(req) {
      const bool = await this.editProductGroup(req);
      console.log(bool);
      if (!bool) {
        this.$Message.error("编辑失败!");
        return false;
      }
      if (!bool.successed) {
        this.$Message.error(bool.msg);
        this.formInline.captcha = "";
        return;
      }
      this.$Message.success("编辑成功!");
      this.$router.push("/exhibition/index/proGroup/productlist");
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 40px auto;
  min-height: 500px;
}
.custom-btn { 
  margin: 0 auto;  
  width: 968px; 
}
</style>